import { useSortStore } from '.'
import { useState } from '../sort/state'

export const toggleSortOrder = () => {
  const sortStore = useSortStore()

  sortStore.sortOrder = -1 * sortStore.sortOrder
}

export const resetSortOrder = () => {
  const sortStore = useSortStore()
  const defaultState = useState()

  sortStore.sortKey = defaultState.sortKey
  sortStore.sortOrder = defaultState.sortOrder
}

export default {
  toggleSortOrder,
  resetSortOrder
}